class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    document.addEventListener('keydown', this.handleEscapeKeyPress.bind(this));
  }

  bindEvents() {
    const drawerBtn = document.querySelector("[data-cart-drawer]");
    if (drawerBtn) {
      drawerBtn.addEventListener('click', this.openCartDrawer.bind(this));
    }
    this.querySelectorAll('[data-close-drawer]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
    this.setupDialogEvents();
    
  }

  setupDialogEvents() {
    let lastFocusedElement = '';
    Array.from(this.querySelectorAll('.modal-dialog-button')).forEach((openBtn) => {
      openBtn.addEventListener('click', (e) => {
        const modalId = openBtn.dataset.modal;
        const dialog = this.querySelector(`cart-dialog#${modalId}`);
        if (dialog) {
          setTimeout(() => {
            dialog.classList.add('is-visible');
            setTimeout(() => {
              lastFocusedElement = openBtn;
              trapFocusElements(dialog);
            }, 600);
          }, 500);
        }
      });
    });
    Array.from(this.querySelectorAll('[data-dialog-close]')).forEach((closeBtn) => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const dialog = closeBtn.closest('cart-dialog');
        dialog.classList.remove('is-visible');
        trapFocusElements(document.querySelector("cart-drawer"));
        setTimeout(() => {
          if (lastFocusedElement) {
            lastFocusedElement.focus();
          }
          lastFocusedElement = '';
        }, 400);
      });
    });
  }

  openCartDrawer(event) {
    event.preventDefault();
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        this.innerHTML = this.getSectionHTML(html, 'cart-drawer');
        
        this.classList.add("is-visible");
        document.querySelector("body").classList.add("overflow-hidden");
        this.querySelectorAll('[data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );
        setTimeout(() => {
        focusElement = event.target;
          trapFocusElements(document.querySelector("cart-drawer"));
        }, 500);

        const totalPrice =  document.querySelector("#cart-drawer-body-content").getAttribute("data-cart-price");
            freeShippingBarProgress(totalPrice);
        console.log(totalPrice,"totaPricetotaPricetotaPrice")
        this.setupDialogEvents();
       
     
      })
      .catch(e => console.error(e));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
    
      if (document.getElementById(section.id)) {
        const sectionHTML = this.getSectionHTML(parsedState.sections[section.id], section.selector);
        document.querySelector(section.selector).innerHTML = sectionHTML;

        const totalCount = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html').querySelector("#cart-drawer-body-content").getAttribute("data-cart-count");
        const priceElement = document.querySelector("[data-cart-price]");
         if (priceElement) {
          const totalPrice = parseInt(priceElement.dataset.cartPrice);
             freeShippingBarProgress(totalPrice);
        }
        const itemCountElement = document.querySelector("[data-item-count]");
        console.log(itemCountElement)
        if (itemCountElement) {
          itemCountElement.classList.remove("hidden");

          if (totalCount == 0) {
            itemCountElement.classList.add("hidden");
          } else if (totalCount < 100) {
            itemCountElement.textContent = totalCount;
          } else {
            itemCountElement.textContent = '99+';
          }
        }
          trapFocusElements(document.querySelector("cart-drawer"));
        

        this.setupDialogEvents();
        this.querySelectorAll('[data-drawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );

      }
    }));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }

  getSectionHTML(html, selector = 'cart-drawer') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector("cart-drawer").innerHTML;
  }

  closeDrawer(event) {
    event.preventDefault();
    if (this.classList.contains("is-visible")) {
      this.classList.remove("is-visible");
      document.querySelector("body").classList.remove("overflow-hidden");
    }
    if (focusElement) {
      focusElement.focus();
    }
    focusElement = '';
    removeTrapFocus();
  }

  handleEscapeKeyPress(event) {
    if (event.key === 'Escape') {
      this.closeDrawer(event);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

/* Cart drawer upsell: clicking a size chip adds that size directly, so the
   customer picks a size instead of picking a size and then hunting for the +.

   Bound on document, not inside the drawer: the drawer replaces its own
   innerHTML when it opens and after every add, which would throw away any
   listener bound within it (and any inline <script>, since scripts inserted
   via innerHTML never run).

   Only pointer interaction adds. Arrow keys move through a radio group and
   fire a click for every value passed on the way, which would add several
   items before reaching the wanted one. Matching each click against a
   preceding pointerdown filters those out — a keyboard-synthesised click has
   no pointerdown behind it — while still covering mouse, touch and pen. */
(() => {
  const ADDING_CLASS = 'is-adding';
  const SAFETY_TIMEOUT = 10000;

  let pointerItem = null;
  let addingCard = null;
  let addingTimer = null;

  const clearAdding = () => {
    if (addingTimer) {
      clearTimeout(addingTimer);
      addingTimer = null;
    }
    if (addingCard) {
      addingCard.classList.remove(ADDING_CLASS);
      addingCard = null;
    }
  };

  const markAdding = (card) => {
    clearAdding();
    addingCard = card;
    card.classList.add(ADDING_CLASS);
    // A successful add replaces the whole drawer, so the class leaves with the
    // old markup. An error does not re-render, and a network failure is only
    // caught and logged without publishing anything, so nothing would clear
    // the state and the card would sit disabled forever. Hence the timeout.
    addingTimer = setTimeout(clearAdding, SAFETY_TIMEOUT);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, clearAdding);
    subscribe(PUB_SUB_EVENTS.cartError, clearAdding);
  }

  document.addEventListener('pointerdown', (event) => {
    pointerItem = event.target.closest ? event.target.closest('.upsell-variant-item') : null;
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest) return;
    const item = event.target.closest('.upsell-variant-item');
    if (!item || item !== pointerItem) return;
    pointerItem = null;

    /* Deferred a tick because a radio's activation behaviour — which is what
       lets variant-set-option write the chosen variant into the form's hidden
       id input — runs after the click event finishes propagating. Reading it
       synchronously here would submit the previously selected variant.
       Re-clicking the already-selected chip fires no change at all, and works
       for the same reason: the input already holds that variant. */
    setTimeout(() => {
      const card = item.closest('.cart-drawer-upsell');
      const addButton = card && card.querySelector('[name="add"]');
      // Disabled means either the size is unavailable (setUnavailableCardButton)
      // or an add is already in flight (product-addtocart-form re-entry guard).
      if (!addButton || addButton.disabled) return;
      markAdding(card);
      addButton.click();
    }, 0);
  });
})();
